var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.handleRoute}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }